export class BillingModel {
    public Name: string;
    public Vatnr: string;
    // public PhoneNumber: string;
    public Address: string;
    public Postcode: string;
    public City: string;
    public Country: string;

    public constructor(data?: BillingModel) {
        this.Name = (data && data.Name) ? data.Name : '';
        this.Vatnr = (data && data.Vatnr) ? data.Vatnr : '';
        // this.PhoneNumber = (data && data.PhoneNumber) ? data.PhoneNumber : '';
        this.Address = (data && data.Address) ? data.Address : '';
        this.Postcode = (data && data.Postcode) ? data.Postcode : '';
        this.City = (data && data.City) ? data.City : '';
        this.Country = (data && data.Country) ? data.Country : '';
    }
}
